import { handleActions } from 'redux-actions';
import actionTypes from 'redux/report/action-types';
import Report from './type';

const initialState: Report = {
    selectedTags: [],
    analyseIndex: [],
    maxDate: 0,
};

export default handleActions(
    {
        [actionTypes.REPORT.GET_USER_ANALYSE_SUCCESS]: (state, { payload }) => ({
            ...state,
            analyseIndex: payload.analyseIndex,
        }),

        [actionTypes.REPORT.SET_SELECTED_TAGS]: (state, { payload }) => ({
            ...state,
            selectedTags: payload.selectedTags,
        }),

        [actionTypes.REPORT.GET_MAX_DATE_SUCCESS]: (state, { payload }) => ({
            ...state,
            maxDate: payload.maxDate,
        }),
    },
    initialState
);
